export default { sha: 'f42787da149133133db009c7d2ab8c862889ab76', buildNumber: 'undefined' }
